import { Box, Grid, styled, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { EmptyStatusCard } from 'src/components/mooring/EmptyStatusCard'
import { MUIThemeColors } from 'src/mui-theme'
import { Card } from 'src/styles/Index'
import { getThemeColor } from 'src/utils'
import { useViewportHeight } from 'src/hooks/useViewportHeight'
import { useGetCustomersNameWithPermissions } from '../../api/customer'
import NoNews from '../../assets/svg/no-locality-content.svg'
import { CenteredSpinner } from '../../components/Spinner'
import NewsFeed from '../../components/news/NewsFeed'
import { LocalitiesMapComponent } from './LocalitiesMapComponent'
import AllLocalities from './container/AllLocalities'

const LocalityMainPage = () => {
  const viewportHeight = useViewportHeight()
  const [open, setOpen] = useState(0)
  const [searchValue, setSearchValue] = useState('')
  const { data, isLoading, isSuccess } = useGetCustomersNameWithPermissions()
  const { hash } = useLocation()
  const theme = useTheme()
  const { t: translate } = useTranslation(['common'])

  useEffect(() => {
    const currentCustomerId = localStorage.getItem('currentCustomerId')
    const customer = data?.find(c => c.id.toString() === currentCustomerId)
    if (currentCustomerId) {
      setOpen(parseInt(currentCustomerId))
      if (customer?.isAdminCustomer) localStorage.setItem('selectedCustomerAdminCustomerId', currentCustomerId)
    } else if (data && data?.length > 0) {
      setOpen(data[0]?.id)
    }
  }, [data])

  useEffect(() => {
    setSearchValue(hash.replace('#', ''))
  }, [hash])

  return (
    <>
      <Box className="relative z-10 h-full overflow-hidden" sx={{ width: '100%', backgroundColor: getThemeColor(theme, MUIThemeColors.white) }}>
        {isLoading && <CenteredSpinner />}
        {isSuccess && (
          <Box className="pt-1">
            <Grid container>
              <LocalitiesContainer
                item
                md={7}
                lg={7}
                sm={12}
                className="hide-scrollbar"
                maxHeight={viewportHeight - 162}
              >
                {data && data.length === 0 ? (
                  <Box
                    py={8}
                    className="text-center"
                    height={'100%'}
                    sx={{ backgroundColor: getThemeColor(theme, MUIThemeColors.white) }}
                  >
                    <EmptyStatusCard
                      imageWidth="132px"
                      image={NoNews}
                      header={translate('customer-empty-status-title', { ns: 'common' })}
                      content={translate('customer-empty-status-content', { ns: 'common' })}
                      headerFontSize="18px"
                      contentFontSize="14px"
                      contentTopMargin="10px"
                      imageContainerClasses="pb-4"
                      height="100%"
                      contentClasses="mt-1"
                    />
                  </Box>
                ) : (
                  <AllLocalities customers={data} open={open} setOpen={setOpen} />
                )}
              </LocalitiesContainer>
              <Grid item md={5} lg={5} sm={12} className="pl-16-core">
                <LocalitiesMapComponent selectedCustomer={open} searchValue={searchValue} />
                <Box className="pt-16-core">
                  <Card
                    className="p-4-core scrollbar"
                    sx={{
                      height: ((viewportHeight - 112) * 1) / 3 - 20,
                      boxShadow: 'none',
                      border: 'none',
                      overflowY: 'auto',
                    }}
                  >
                    {open ? (
                      <NewsFeed
                        customerId={open}
                        isCustomerAdmin={data?.find(c => c.id === open)?.isAdminCustomer}
                        hasLocalities={data?.find(c => c.id === open)?.hasLocalities}
                        hasServiceStations={false}
                        hasStorages={false}
                      />
                    ) : (
                      <Box py={8} className="text-center" height={'100%'}>
                        <EmptyStatusCard
                          imageWidth="132px"
                          image={NoNews}
                          header={translate('news-empty-status-title', { ns: 'common' })}
                          content={translate('news-empty-status-content', { ns: 'common' })}
                          headerFontSize="18px"
                          contentFontSize="14px"
                          contentTopMargin="10px"
                          imageContainerClasses="pb-4"
                          height="100%"
                          contentClasses="mt-1"
                        />
                      </Box>
                    )}
                  </Card>
                </Box>
              </Grid>
            </Grid>
          </Box>
        )}
      </Box>
    </>
  )
}

export default LocalityMainPage

//styled components
const LocalitiesContainer = styled(Grid)<{ maxHeight: number }>`
  overflow-y: auto;
  max-height: ${props => props.maxHeight}px;
`
